import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ControlsModule } from "src/app/controls/controls.module";
import { CoreModule } from "src/app/core/core.module";
import { TranslateModule } from "@ngx-translate/core";
import { LearnWithAiComponent } from "./learn-with-ai.component";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";

@NgModule({
  declarations: [
    LearnWithAiComponent
  ],
  imports: [
    CommonModule,
    ControlsModule,
    FormsModule,
    SharedModule,
    CoreModule,
    TranslateModule
],
  exports: [
    LearnWithAiComponent
  ]
})
export class LearnWithAiModule { }